<template>
    <div>
        <FormSection title="Clinical Information" :full-height="false" :application-id="application">
            <template #content>
                <section class="row p-2 px-4 pb-0">
                    <div class="col-12 offset-md-1 col-md-10 row">
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Care Team </label>
                            <select class="form-select" v-model="patientDetails.clinicalInformation.careTeamId">
                                <option :value="null">Select Care Team</option>
                                <option v-for="team of teams" :key="team.id" :value="team.id">
                                    {{ team.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Case Manager </label>
                            <TypeaheadInput
                                :getData="getUsersList"
                                :value="caseManager"
                                v-on:valueChanged="updateCaseManager"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Clinical Manager </label>
                            <TypeaheadInput
                                :getData="getUsersList"
                                :value="clinicalManager"
                                v-on:valueChanged="updateClinicalManager"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Admitting RN </label>
                            <TypeaheadInput
                                :getData="getUsersList"
                                :value="admittingRn"
                                v-on:valueChanged="updateAdmittingRN"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Spiritual Care Counselor </label>
                            <TypeaheadInput
                                :getData="getUsersList"
                                :value="spiritualCounselor"
                                v-on:valueChanged="updateSpiritualCounselor"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Social Worker </label>
                            <TypeaheadInput
                                :getData="getUsersList"
                                :value="socialWorker"
                                v-on:valueChanged="updateSocialWorker"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12 col-md-6">
                            <label for="patient-middle-initial"> Aide</label>
                            <TypeaheadInput
                                :getData="getActiveList"
                                :value="aide"
                                v-on:valueChanged="updateAide"
                                placeholder="Start Typing..."
                            >
                            </TypeaheadInput>
                        </div>
                        <div class="form-group col-12">
                            <label for="patient-middle-initial"> Referral Diagnosis </label>
                            <Diagnosis
                                :selected-diagnosis="referralDiagnosis"
                                classes="d-inline-block w-100"
                                :diagnosis-changed="referralDiagnosisChanged"
                                :application="Number(application)"
                            ></Diagnosis>
                        </div>
                        <div class="row col-10 col-md-11">
                            <div class="form-group col-12 col-md-3">
                                <label for="tolerable-pain-level"> Tolerable Pain Level </label>
                                <select
                                    name="tolerable-pain-level"
                                    class="form-select"
                                    v-model="patientDetails.clinicalInformation.tolerablePainLevel"
                                >
                                    <option :value="null">Select Tolerable Pain Level</option>
                                    <option
                                        v-for="painLevel in TolerablePainLevels"
                                        :key="`${painLevel.name}-${painLevel.value}`"
                                        :value="painLevel.value"
                                    >
                                        {{ painLevel.value }} - {{ painLevel.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 pe-4">
                        <DiagnosisTable
                            :diagnosis="patientDetails.clinicalInformation.diagnoses"
                            :updateDiagnosis="updateDiagnosis"
                            :id="patientDetails.clinicalInformation.id"
                            :application="application"
                        />
                    </div>
                    <div class="col-12">
                        <ProblemsTable
                            :problems="patientDetails.clinicalInformation.problems"
                            :updateProblems="updateProblems"
                            :id="patientDetails.clinicalInformation.id"
                            :application="application"
                        />
                    </div>
                </section>
            </template>
        </FormSection>
    </div>
</template>

<script src="./ClinicalInformation.ts"></script>
